export const planConversionBannerTestId = "src/pages/_index/__components__/PlanConversionBanner";

// PNG画像は既存の banner_invite_bonus_top_20261005.png と同様 public/images/ に置き、パス文字列で参照する
// （assets/ からの静的importはSVGのみ対応で、PNGはproductionビルドが通らない）
export const planConversionBannerImage = "/images/banner_plan_conversion.png";
export const planConversionBannerImageWidth = 720;
export const planConversionBannerImageHeight = 233;
export const planConversionBannerAlt =
  "トイサブ！をもっとお得に利用するなら 年間コースなら4,000円以上お得！ 毎月払いから年間コースへの切り替えで、いつものサービス内容はそのまま、お得に続けられます。 年間コースについて詳しく見る";

// 一括転換コース訴求バナーを表示する対象の契約コース名（表示切替で選択中のコースがこの一覧に含まれる場合のみ表示する）
export const planConversionBannerTargetPlanNames = [
  "ACT_スタンダードコース(6点60日交換毎月払い)",
  "ACT_スタンダードコース(友達紹介6点60日交換毎月払い)",
] as const;

// LP: src/pages/lp/plan-conversion（社内向けの暫定URL。5枚のセクション画像とCTA遷移先が揃うまではプレースホルダー表示）
export const planConversionBannerHref = "/lp/plan-conversion";
